// Category values mirror Lib.Common.Models.Enums.Category (a [Flags] enum: 1L << n).
// Only the sports likely to carry bespoke SEO copy are listed; extend as needed.
export const CATEGORY_OPTIONS = [
  { value: '8192', label: 'Padel' },          // 1 << 13
  { value: '2', label: 'Badminton' },         // 1 << 1
  { value: '4', label: 'Tennis' },            // 1 << 2
  { value: '8', label: 'Squash' },            // 1 << 3
  { value: '4096', label: 'Table Tennis' },   // 1 << 12
  { value: '1', label: 'Football' },          // 1 << 0
  { value: '16', label: 'Volleyball' },       // 1 << 4
  { value: '32', label: 'Basketball' },       // 1 << 5
  { value: '128', label: 'Floorball' },       // 1 << 7
  { value: '536870912', label: 'Handball' },  // 1 << 29
];

// Translations.Language: DA = 1, EN = 2, SV = 3
export const LANGUAGE_OPTIONS = [
  { value: '1', label: 'Danish (DA)' },
  { value: '2', label: 'English (EN)' },
  { value: '3', label: 'Swedish (SV)' },
];

export const categoryLabel = (value) =>
  (CATEGORY_OPTIONS.find((o) => o.value === String(value)) || {}).label || String(value);

export const languageLabel = (value) =>
  (LANGUAGE_OPTIONS.find((o) => o.value === String(value)) || {}).label || String(value);
